import React from 'react';

// Nexus Core Design System (DESIGN.md §5.2) - Alert
const variants = {
  info: {
    container: 'bg-nexus-blue-soft/40 border-nexus-blue-soft text-nexus-primary',
    icon: 'info',
    iconColor: 'text-nexus-blue',
  },
  success: {
    container: 'bg-emerald-50 border-emerald-200 text-emerald-700',
    icon: 'check_circle',
    iconColor: 'text-emerald-500',
  },
  warning: {
    container: 'bg-amber-50 border-amber-200 text-amber-700',
    icon: 'warning',
    iconColor: 'text-amber-500',
  },
  error: {
    container: 'bg-red-50 border-red-200 text-red-700',
    icon: 'error',
    iconColor: 'text-red-500',
  },
};

export default function Alert({
  children,
  variant = 'info',
  title,
  icon,
  onClose,
  className = '',
}) {
  const config = variants[variant] || variants.info;

  return (
    <div
      className={`flex items-start gap-3 px-4 py-3 border rounded-lg ${config.container} ${className}`}
      role="alert"
    >
      <div className={`flex-shrink-0 mt-0.5 ${config.iconColor}`}>
        {icon || (
          <span className="material-symbols-outlined text-[20px] leading-none">{config.icon}</span>
        )}
      </div>
      <div className="flex-1 min-w-0">
        {title && (
          <h4 className="font-medium mb-1 text-sm">{title}</h4>
        )}
        <div className="text-sm">{children}</div>
      </div>
      {onClose && (
        <button
          onClick={onClose}
          className="flex-shrink-0 p-1 rounded hover:bg-black/5 transition-colors"
          aria-label="閉じる"
        >
          <span className="material-symbols-outlined text-[18px] leading-none">close</span>
        </button>
      )}
    </div>
  );
}
